export default __webpack_public_path__ + "static/media/747.37a446c9.png";